import { captureException } from '@sentry/react'
import axios from '@/axios-instance-node'
import { PaginatedGeoResponse } from '@/features/subgeo/types.ts'
import { parseResponseData } from '@/helpers/utils'

export interface HttpGetViewOnlyGeosParams {
	geoCode?: string
	page?: number
	limit?: number
}

export const httpGetViewOnlyGeos = async (
	params: HttpGetViewOnlyGeosParams
) => {
	const response = await axios.get('/v1/geo-mapping-geos', {
		params: {
			type: 'view_only',
			responseType: 'small',
			page: params.page ?? 1,
			limit: params.limit ?? 50,
			geoCode: params.geoCode
		}
	})

	return parseResponseData({
		responseData: response.data,
		responseShape: PaginatedGeoResponse,
		onZodError: captureException
	})
}
